import { AuthProviders } from "@outschool/auth-shared";
import { useTranslation } from "@outschool/localization";
import { Component } from "@outschool/ownership-areas";
import { useAuthError } from "@outschool/ui-auth";
import React from "react";

import type { CreateOrLoginError } from "../../../generated/graphql";
import { useLearnerLoginWithRedirect } from "../../../hooks/authentication";

export function useLoginWithRedirect(provider: AuthProviders) {
  const { t } = useTranslation(
    "learnerApp\\Settings\\ConnectThirdPartyAccounts\\connectOidcUtils",
  );

  const [userError, setUserError] = React.useState<React.ReactNode>(null);

  const generateLoginError = useAuthError(provider);
  const url = React.useMemo(() => {
    if (typeof window !== "undefined") {
      return window.location.href;
    }
    return "";
  }, []);
  const handleAuthError = React.useCallback(
    (
      error: unknown,
      message: React.ReactNode = t("Sorry that didn’t work, try again"),
    ) => {
      OsPlatform.captureError(error, {
        tags: { component: Component.LearnerMode },
      });
      setUserError(message);
    },
    [t],
  );
  const handleLoginError = React.useCallback(
    (error: CreateOrLoginError) => {
      const errorObject = new Error(error);
      handleAuthError(errorObject, generateLoginError(error));
    },
    [handleAuthError, generateLoginError],
  );
  // @ts-ignore TS7
  useLearnerLoginWithRedirect(handleLoginError, url);

  return userError;
}
